import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import anime from 'animejs/lib/anime.es';

const fragments = {
  CONTAINER: '[data-fragment="BudgetKnob.container"]',
  KNOB: '[data-fragment="BudgetKnob.knob"]',
  HANDLE: '[data-fragment="BudgetKnob.handle"]',
  LEVEL: '[data-fragment="BudgetKnob.level"]',
  BUDGET: '[data-fragment="BudgetKnob.budget"]',
  INFO: '[data-fragment="BudgetKnob.info"]',
  BUTTON: '[data-fragment="BudgetKnob.button"]',
};

export default class BudgetKnob extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      moving: false,
      realAngle: 0,
      fakeAngle: 0,
      activeRealAngle: 0,
      snapping: false,
      budget: 0,
      buttonLink: null
    };
    this.startMoving = this.startMoving.bind(this);
    this.stopMoving = this.stopMoving.bind(this);
    this.move = this.move.bind(this);
    this.calcAngle = this.calcAngle.bind(this);
    this.calcFakeAngle = this.calcFakeAngle.bind(this);
    this.calcRealAngle = this.calcRealAngle.bind(this);
    this.setLevels = this.setLevels.bind(this);
    this.snapTo = this.snapTo.bind(this);
    this.goTo = this.goTo.bind(this);
  }
  didMount() {
    this.container = this.element.querySelector(fragments.CONTAINER);
    this.knob = this.element.querySelector(fragments.KNOB);
    this.handle = this.element.querySelector(fragments.HANDLE);
    this.budget = this.element.querySelector(fragments.BUDGET);
    this.levels = this.element.querySelectorAll(fragments.LEVEL);
    this.info = this.element.querySelectorAll(fragments.INFO);
    this.button = this.element.querySelector(fragments.BUTTON);
    this.externalButtons = document.querySelectorAll('.js_budget-configurator-button');
    this.on('mousedown', fragments.HANDLE, this.startMoving);
    this.on('touchstart', fragments.HANDLE, this.startMoving);
    window.addEventListener('mouseup', this.stopMoving);
    window.addEventListener('touchend', this.stopMoving);
    window.addEventListener('mousemove', this.move);
    this.on('touchmove', fragments.HANDLE, this.move);
    this.on('click', fragments.LEVEL, this.goTo);
    for (let i = 0; i < this.levels.length; i++) {
      const partialAngle = 240 / 16;
      this.levels[i].fakeAngle = partialAngle * i;
      if (this.levels[i].dataset.active) {
        this.setState({
          realAngle: this.calcRealAngle(partialAngle * i),
          fakeAngle: partialAngle * i,
          activeRealAngle: this.calcRealAngle(partialAngle * i)
        });
      }
    }
    this.setState({
      buttonLink: this.button.getAttribute('href')
    });
    this.setLevels();
    this.snapTo(this.state.activeRealAngle);
  }
  startMoving = () => {
    this.setState({
      moving: true,
    });
  };
  stopMoving = () => {
    if (this.state.moving && !this.state.snapping) {
      this.setState({
        moving: false,
      });
      this.snapTo(this.state.activeRealAngle);
      this.gaDataLayerStop();
    }
  };

  gaDataLayerStop = () => {
    let tabsNavItemActive = document.querySelector('.tabs__nav-item--active');
    let fgBudgetCategory = '';
    if(tabsNavItemActive) {
      fgBudgetCategory = tabsNavItemActive.innerHTML;
    }
    dataLayer.push({
      'event': 'fgWebBudgetTool',
      'fgBudget': this.budget.innerHTML.replace(/ /g, ''),
      'fgBudgetCategory': fgBudgetCategory,
    });
  };

  move = (e) => {
    e.preventDefault();
    if (this.state.moving && !this.state.snapping) {
      let angle = this.calcAngle(e);
      if (angle >= -30 && angle <= 210) {
        this.knob.style.transform = `rotateZ(${angle}deg)`;
      } else if (angle < -30) {
        this.knob.style.transform = `rotateZ(-30deg)`;
        angle = -30;
      } else if (angle > 210) {
        this.knob.style.transform = `rotateZ(210deg)`;
        angle = 210;
      }
      this.setState({
        realAngle: angle,
        fakeAngle: this.calcFakeAngle(angle),
      });
      this.setLevels();
    }
  };
  calcAngle = (e) => {
    let res = 0;
    let mouseX = null;
    let mouseY = null;
    if (e.type === "mousemove") {
      mouseX = e.clientX;
      mouseY = e.clientY;
    } else if (e.type === "touchmove") {
      mouseX = e.touches[0].clientX;
      mouseY = e.touches[0].clientY;
    }
    let centerOffsetX = this.container.getBoundingClientRect().left + (this.knob.clientWidth/2) - mouseX;
    let centerOffsetY = this.container.getBoundingClientRect().top + (this.knob.clientHeight/2) - mouseY;
    let angle = (Math.atan2(centerOffsetY, centerOffsetX) * 180 / Math.PI);
    if (angle < -90 && angle >= -180) {
      res = 360 + angle;
    } else {
      res = angle;
    }
    return res;
  };
  calcFakeAngle = (realAngle) => {
    return realAngle + 30;
  };
  calcRealAngle = (fakeAngle) => {
    return fakeAngle - 30;
  };
  setLevels = () => {
    const partialAngle = 240 / 16;
    let reachedAngle = 0;
    for (let i = 0; i < this.levels.length; i++) {
      reachedAngle = partialAngle * i;
      if (this.state.fakeAngle >= (reachedAngle - 1)) {
        this.levels[i].classList.add('budget-knob__level--reached');
      } else {
        this.levels[i].classList.remove('budget-knob__level--reached');
      }
      if ((reachedAngle > (this.state.fakeAngle - (partialAngle / 2))) && (reachedAngle < (this.state.fakeAngle + (partialAngle / 2)))) {
        this.levels[i].classList.add('budget-knob__level--active');
        if (this.levels[i].dataset.info) {
          for (let j = 0; j < this.info.length; j++) {
            if (this.levels[i].dataset.info === this.info[j].getAttribute('id')) {
              this.info[j].classList.add('budget-knob__info--active');
              setTimeout(() => {
                this.info[j].classList.add('budget-knob__info--animate');
              }, 50);
              let button = this.info[j].querySelector(fragments.BUTTON);
              let buttonHref = `${this.state.buttonLink}&frm.expectedBudget=${i + 1}`;
              if(this.externalButtons.length > 0) {
                for(let k = 0; k < this.externalButtons.length; k++) {
                    this.externalButtons[k].setAttribute('href', buttonHref);
                }
              }
              button.setAttribute('href', buttonHref);
            } else {
              this.info[j].classList.remove('budget-knob__info--active');
              this.info[j].classList.remove('budget-knob__info--animate');
            }
          }
        }
        this.setState({
          activeRealAngle: this.calcRealAngle(reachedAngle),
          budget: this.levels[i].dataset.budget
        });
      } else {
        this.levels[i].classList.remove('budget-knob__level--active');
      }
    }
  };
  snapTo = (levelAngle) => {
    this.setState({
      snapping: true
    });
    anime({
      targets: this.knob,
      rotateZ: levelAngle,
      duration: 500
    });
    setTimeout(() => {
      this.setState({
        snapping: false
      }, 500);
    });
  };
  goTo = (e) => {
    let realAngle = this.calcRealAngle(e.target.fakeAngle);
    this.setState({
      fakeAngle: e.target.fakeAngle,
      activeRealAngle: realAngle,
      realAngle: realAngle,
      snapping: true
    });
    anime({
      targets: this.knob,
      rotateZ: realAngle,
      duration: 300,
      easing: 'easeOutQuad'
    });
    this.setLevels();
    setTimeout(() => {
      this.setState({
        snapping: false
      });
    }, 1000);
  };
  update() {
    const { moving } = this.state;
    classNames(this.handle, {
      'active': moving,
    });
    this.budget.innerHTML = this.state.budget;
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/BudgetKnob.js